var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-1.428 3h2.856a4.07 4.07 0 0 1 4.031 3.5H3.541A4.07 4.07 0 0 1 7.57 15m0-1.5A5.57 5.57 0 0 0 2 19.072c0 .512.416.928.928.928h12.144a.93.93 0 0 0 .928-.928 5.57 5.57 0 0 0-5.572-5.572zm10.178.25c0 .416.334.75.75.75s.75-.334.75-.75v-2h2c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-2v-2a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v2h-2A.75.75 0 0 0 15 11c0 .416.334.75.75.75h2z"
  })));
};
export default SvgUserPlus;